import { Typography } from "@/design-system/Atoms";
import { useCallback } from "react";

interface ContactUsHeroBannerProps {
    imageSrc: string;
    scrollTarget?: string;
}

const ContactUsHeroBanner = ({ imageSrc, scrollTarget }: ContactUsHeroBannerProps) => {
    const handleArrowClick = useCallback(() => {
        if (scrollTarget) {
            const targetElement = document.getElementById(scrollTarget);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }, [scrollTarget]);


    return (

        <section
            className={`relative w-full lg:h-[65vh] bg-center bg-cover flex justify-center items-center`}
            style={{
                backgroundImage: `url(${imageSrc})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
            }}

        >
            <div className="absolute inset-0 bg-[rgba(0,0,0,.6)]" />

            <div className="container relative z-10 pt-20 px-4">
                <div className="flex flex-col lg:flex-row-reverse gap-y-10 lg:gap-16">
                    <div className="lg:ml-auto lg:w-[31%]">
                        <div className="rounded-[20px] bg-white/5 backdrop-blur-[20px] p-8 text-white">
                            <h2 className="text-white text-[1.25rem] mb-2">Hours of Operation</h2>
                            <p className="text-[1rem]">
                                Monday – Friday | 8:00 AM – 9:00 PM ET<br />
                                Saturday | 9:00 AM – 2:00 PM EST<br />
                                Sunday – Monday | CLOSED
                            </p>
                            <hr className="my-4 border-white/20" />
                            <p className="mb-4">
                                Call: <a href="tel:8134457342" className="hover:text-gray-200">813-445-7342</a><br />
                                Email: <a href="mailto:Care@DefyMedical.com" className="hover:text-gray-200">Care@DefyMedical.com</a>
                            </p>
                        </div>
                    </div>

                    <div className={`w-full lg:w-[38%] lg:px-0 pt-6 lg:pt-0`}>
                        <Typography variant="heroBannerTitle" as="h1" className="mb-4" >
                            Contact Us
                        </Typography>

                        <Typography variant={`sectionDescriptionSmall`} as="p" className="mb-[3.75rem] text-white">
                            Have questions or need assistance? Contact our dedicated team today for personalized support and expert guidance.
                        </Typography>

                    </div>
                </div>
            </div>

            <div className="pointer-events-none absolute bottom-0 left-1/2 w-[9.8125rem] h-[2.1875rem] bg-[url('/images/bg-hero-arrow.svg')] bg-no-repeat transform -translate-x-1/2 z-30">
                <img
                    onClick={handleArrowClick}
                    src="/images/icons/hero-down-arrow.svg"
                    alt="Down Arrow"
                    className="pointer-events-auto hover:border-[#d6d9e1] hover:rounded-full w-[3.5625rem] h-[3.5rem] absolute bottom-[-2.25rem] left-1/2 transform -translate-x-1/2 cursor-pointer border-[0.25rem] border-transparent transition-all duration-500 ease-in-out z-40"
                />
            </div>
        </section>
    );
};

export default ContactUsHeroBanner;